import { Duration } from './settings'
import { Price } from './price-cap'
import { Factory } from '../interface/factory'
import { applyEntitySchema, sourceJson } from '../../_utils/fcdc-v2'
import { priceSlotSchema, priceSlotsSchema } from '../schema/pricing.schema'

export class PriceSlot {
  priceCategoryId: string
  length: Duration
  price: Price

  constructor(json: any) {
    const source = sourceJson(json) as Record<string, unknown>
    const price = sourceJson(source['price'])
    const plain: Record<string, unknown> = { ...source, price }
    this.priceCategoryId = plain['priceCategoryId'] as string
    this.length = plain['length'] as Duration
    this.price = new Price(price)
    applyEntitySchema(this, priceSlotSchema, plain, {})
  }

  static getFactory(): Factory<PriceSlot> {
    return new (class implements Factory<PriceSlot> {
      make(json: any): PriceSlot {
        return new PriceSlot(json)
      }

      getTableName(): string {
        throw new Error(
          'getTableName() should never be called on a PriceSlot. PriceSlots are not stored in IndexDB.'
        )
      }
    })()
  }
}

export class PriceSlots {
  slots: PriceSlot[]
  overflowSlot: PriceSlot[]

  constructor(json: any) {
    const source = sourceJson(json) as any
    this.slots = Array.isArray(source.slots)
      ? source.slots.map((slot: any) => new PriceSlot(slot))
      : []
    this.overflowSlot = Array.isArray(source.overflowSlot)
      ? source.overflowSlot.map((slot: any) => new PriceSlot(slot))
      : []
    applyEntitySchema(this, priceSlotsSchema, source, {
      slots: [],
      overflowSlot: [],
    })
  }

  isValid(): boolean {
    const categoriesInSlots = new Set<string>()

    this.slots.forEach(slot => {
      categoriesInSlots.add(slot.priceCategoryId)
    })

    for (const categoryId of categoriesInSlots) {
      const hasOverflow = this.overflowSlot.some(
        overflow => overflow.priceCategoryId === categoryId
      )

      if (!hasOverflow) {
        return false
      }
    }

    return true
  }

  static getFactory(): Factory<PriceSlots> {
    return new (class implements Factory<PriceSlots> {
      make(json: any): PriceSlots {
        return new PriceSlots(json)
      }

      getTableName(): string {
        throw new Error(
          'getTableName() should never be called on a PriceSlots. PriceSlots are not stored in IndexDB.'
        )
      }
    })()
  }
}
